.setting-sidebar-main {
  transition: all 0.3s ease;
  background: #fff;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  overflow-x: visible;
  /* Only the inner .sidebar-list scrolls — avoid nested scrollbars + empty gap below items */
  overflow-y: hidden;
  width: 100% !important;
  min-width: 292px !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box !important;
}

.setting-sidebar-main .sidebar-list {
  padding: 8px 0;
  width: 100% !important;
  min-width: 292px !important;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: visible;
  box-sizing: border-box !important;
}

/* MUI ListItemText defaults to overflow:hidden + nowrap → clips “Theme & appearance” */
.setting-sidebar-main .sidebar-list .MuiListItem-root,
.setting-sidebar-main .sidebar-list .MuiListItemButton-root {
  align-items: flex-start;
  overflow: visible;
}

.setting-sidebar-main .MuiListItemText-root {
  overflow: visible !important;
  max-width: 100% !important;
}

.setting-sidebar-main .MuiListItemText-root .MuiTypography-root {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.setting-sidebar-main .sidebar-item {
  padding: 12px 16px;
  margin: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.setting-sidebar-main .sidebar-item.active {
  background-color: rgba(6, 49, 100, 0.08);
  border-left: 4px solid #0f2b46;
  box-shadow: var(--shadow-md);
}

.setting-sidebar-main .sidebar-item.active-donor {
  background-color: rgba(41, 179, 226, 0.15);
  border-left: 4px solid #29B3E2;
  box-shadow: var(--shadow-md);
}

.mobile-menu-button{
  margin-left: -25px !important;
  margin-bottom: 10px !important;
}
.setting-sidebar-main .sidebar-item:hover {
  transform: translateX(4px);
}

.setting-sidebar-main .MuiListItemIcon-root {
  min-width: 40px !important;
  color: #0f2b46;
  transition: all 0.2s ease;
}

.setting-sidebar-main .sidebar-item:hover .MuiListItemIcon-root {
  /* color: #2d5a1f; */
  transform: scale(1.1);
}

.setting-sidebar-main .MuiListItemText-primary {
  font-size: 14px;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  overflow: visible;
  text-overflow: clip;
  /* color: #2c3e50; */
  transition: all 0.2s ease;
}

.setting-sidebar-main .sidebar-item:hover .MuiListItemText-primary {
  /* color: #1e293b; */
  font-weight: 600;
}

.setting-sidebar-main .sidebar-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 10;
  min-height: 60px;
}

.setting-sidebar-main .sidebar-header.collapsed {
  justify-content: center !important;
  padding: 16px 8px !important;
  min-height: 60px !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}

.setting-sidebar-main .sidebar-header.collapsed .collapse-button {
  margin: 0 auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  background: #f0f8f0 !important;
  border: 1px solid #0f2b46 !important;
  border-radius: 4px !important;
  box-shadow: var(--shadow-md) !important;
  color: #0f2b46 !important;
  position: relative !important;
  cursor: pointer !important;
  font-size: 18px !important;
  font-weight: bold !important;
  outline: none !important;
}

.setting-sidebar-main .sidebar-title {
  font-weight: 600;
  /* color: #1e293b; */
  font-size: 18px;
  flex: 1;
}

.setting-sidebar-main .collapse-button {
  padding: 8px !important;
  color: #0f2b46 !important;
  background: #f0f8f0 !important;
  border: 1px solid #0f2b46 !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
  flex-shrink: 0 !important;
  z-index: 15 !important;
  min-width: 32px !important;
  min-height: 32px !important;
  width: 32px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  visibility: visible !important;
  opacity: 1 !important;
  margin: 0 auto !important;
  box-shadow: var(--shadow-md) !important;
  cursor: pointer !important;
  font-size: 18px !important;
  font-weight: bold !important;
  outline: none !important;
}

.setting-sidebar-main .collapse-button:hover {
  background: rgba(6, 49, 100, 0.08) !important;
  transform: scale(1.1) !important;
  border: 1px solid rgba(79, 150, 59, 0.2) !important;
}

.setting-sidebar-main .collapse-button svg {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  fill: #0f2b46 !important;
}

.setting-sidebar-main .collapse-button .MuiSvgIcon-root {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  fill: #0f2b46 !important;
}

.setting-sidebar-main .collapse-button:hover {
  background: rgba(6, 49, 100, 0.08);
  transform: scale(1.1);
  border: 1px solid rgba(79, 150, 59, 0.2);
}

.setting-sidebar-main:not(.expanded) .sidebar-header {
  justify-content: center !important;
  display: flex !important;
  align-items: center !important;
}

.setting-sidebar-main:not(.expanded) .sidebar-header .collapse-button {
  visibility: visible !important;
  opacity: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
}

.setting-sidebar-main:not(.expanded) .sidebar-item {
  justify-content: center;
  padding: 12px 8px;
}

.setting-sidebar-main:not(.expanded) .MuiListItemIcon-root {
  margin: 0 auto;
}

/* Expanded state styles - ensure full text is visible */
.setting-sidebar-main.expanded {
  width: 100% !important;
  min-width: 292px !important;
}

.setting-sidebar-main.expanded .sidebar-header {
  justify-content: flex-start !important;
  padding: 16px !important;
}

.setting-sidebar-main.expanded .sidebar-title {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.setting-sidebar-main.expanded .sidebar-item {
  justify-content: flex-start !important;
  padding: 12px 16px !important;
  flex-direction: row !important;
}

.setting-sidebar-main.expanded .MuiListItemIcon-root {
  margin-right: 12px !important;
  margin-left: 0 !important;
  min-width: 40px !important;
  margin: 0 12px 0 0 !important;
}

.setting-sidebar-main.expanded .MuiListItemText-root {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  flex: 1 !important;
}

.setting-sidebar-main.expanded .MuiListItemText-primary {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.setting-sidebar-main .collapse-button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
}

.setting-sidebar-main .collapse-button .MuiSvgIcon-root {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  fill: #0f2b46 !important;
  font-size: 20px !important;
}

.setting-sidebar-main .sidebar-header.collapsed .collapse-button .MuiSvgIcon-root {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  fill: #0f2b46 !important;
  font-size: 20px !important;
}

.setting-sidebar-main .sidebar-header.collapsed .collapse-button .MuiSvgIcon-root,
.setting-sidebar-main .collapse-button .MuiSvgIcon-root {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  color: #0f2b46 !important;
  fill: #0f2b46 !important;
  font-size: 20px !important;
  transform: none !important;
}

.mobile-menu-button {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1200;
  /* background: #0f2b46 !important; */
  color: white !important;
  box-shadow: var(--shadow-lg);
}

.mobile-menu-button:hover {
  /* background: #0f2b46 !important; */
  transform: scale(1.05);
}

/* In-flow trigger (e.g. Theme on narrow screens) — do not cover cards / main nav */
.mobile-menu-button.mobile-menu-button--inline {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  margin-left: 0 !important;
  margin-bottom: 0 !important;
  z-index: 2;
}

.mobile-drawer .MuiDrawer-paper {
  width: min(304px, 88vw);
  max-width: 88vw;
  background: #fff;
  box-shadow: var(--shadow-md);
}

.mobile-drawer .setting-sidebar-main {
  margin-top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile-drawer .MuiDrawer-paper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.desktop-sidebar-container {
  position: relative;
  height: 100vh;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 10 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  box-sizing: border-box !important;
}

/* Settings Layout Container */
.settings-layout-container {
  min-height: 100vh;
  position: relative;
}

.settings-layout-container .hiren {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-x: visible;
  overflow-y: auto;
}

/* Scrollbar styles for Webkit browsers (Chrome, Safari, Edge) */
.setting-sidebar-main::-webkit-scrollbar,
.setting-sidebar-main .sidebar-list::-webkit-scrollbar {
  width: 8px;
}

.setting-sidebar-main::-webkit-scrollbar-track,
.setting-sidebar-main .sidebar-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.setting-sidebar-main::-webkit-scrollbar-thumb,
.setting-sidebar-main .sidebar-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.setting-sidebar-main::-webkit-scrollbar-thumb:hover,
.setting-sidebar-main .sidebar-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Scrollbar styles for Firefox */
.setting-sidebar-main,
.setting-sidebar-main .sidebar-list {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* Responsive Breakpoints */

@media (min-width: 1680px) {
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 320px !important;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 16px 20px;
    margin: 6px 12px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 16px;
  }
}

@media (max-width: 1679px) and (min-width: 1440px) {
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 304px !important;
  }
}

@media (max-width: 1439px) and (min-width: 1280px) {
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 300px !important;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 10px 14px;
    margin: 3px 6px;
  }
}

@media (max-width: 1279px) and (min-width: 1024px) {
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 288px !important;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 8px 12px;
    margin: 2px 4px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 13px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 272px !important;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 8px 10px;
    margin: 2px 4px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 12px;
  }
  
  .setting-sidebar-main .sidebar-title {
    font-size: 16px;
  }
}

/* Mobile Large (576px - 767px) */
@media (max-width: 767px) and (min-width: 576px) {
  .mobile-drawer .MuiDrawer-paper {
    width: 260px;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 12px 16px;
    margin: 4px 8px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 14px;
  }
}

@media (max-width: 575px) and (min-width: 425px) {
  .mobile-drawer .MuiDrawer-paper {
    width: 240px;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 10px 14px;
    margin: 3px 6px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 13px;
  }
  
  .setting-sidebar-main .sidebar-title {
    font-size: 16px;
  }
}

@media (max-width: 424px) and (min-width: 375px) {
  .mobile-drawer .MuiDrawer-paper {
    width: 220px;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 8px 12px;
    margin: 2px 4px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 12px;
  }
  
  .setting-sidebar-main .sidebar-title {
    font-size: 15px;
  }
  
  .mobile-menu-button {
    top: 15px;
    left: 15px;
  }

  .mobile-drawer .setting-sidebar-main,
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
  }
  .setting-sidebar-main .sidebar-list {
    width: 100% !important;
    min-width: 0 !important;
  }
}

@media (max-width: 374px) and (min-width: 320px) {
  .mobile-drawer .MuiDrawer-paper {
    width: 200px;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 8px 10px;
    margin: 2px 4px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 11px;
  }
  
  .setting-sidebar-main .sidebar-title {
    font-size: 14px;
  }
  
  .mobile-menu-button {
    top: 10px;
    left: 10px;
  }

  .mobile-drawer .setting-sidebar-main,
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
  }
  .setting-sidebar-main .sidebar-list {
    width: 100% !important;
    min-width: 0 !important;
  }
}

/* Mobile Tiny (below 320px) */
@media (max-width: 319px) {
  .mobile-drawer .MuiDrawer-paper {
    width: 180px;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 6px 8px;
    margin: 1px 2px;
  }
  
  .setting-sidebar-main .MuiListItemText-primary {
    font-size: 10px;
  }
  
  .setting-sidebar-main .sidebar-title {
    font-size: 13px;
  }
  
  .mobile-menu-button {
    top: 8px;
    left: 8px;
  }

  .mobile-drawer .setting-sidebar-main,
  .setting-sidebar-main {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
  }
  .setting-sidebar-main .sidebar-list {
    width: 100% !important;
    min-width: 0 !important;
  }
}

/* Landscape orientation adjustments for mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .setting-sidebar-main {
    height: 100%;
    overflow-y: hidden;
  }
  
  .setting-sidebar-main .sidebar-item {
    padding: 6px 12px;
    margin: 2px 4px;
  }
  
  .setting-sidebar-main .sidebar-header {
    padding: 12px 16px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .setting-sidebar-main {
    box-shadow: var(--shadow-md);
  }
  
  .mobile-menu-button {
    box-shadow: var(--shadow-lg);
  }
}

/* Reduced motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  .setting-sidebar-main,
  .setting-sidebar-main .sidebar-item,
  .setting-sidebar-main .collapse-button,
  .setting-sidebar-main .MuiListItemIcon-root,
  .setting-sidebar-main .MuiListItemText-primary {
    transition: none;
  }
  
  .setting-sidebar-main .sidebar-item:hover {
    transform: none;
  }
  
  .setting-sidebar-main .sidebar-item:hover .MuiListItemIcon-root {
    transform: none;
  }
  
  .setting-sidebar-main .collapse-button:hover {
    transform: none;
  }
  
  .mobile-menu-button:hover {
    transform: none;
  }
}

/* Mobile specific collapsed styles */
@media (max-width: 1023px) {
  .setting-sidebar-main .sidebar-header.collapsed {
    padding: 12px 6px;
  }
  
  .setting-sidebar-main .collapse-button {
    padding: 6px;
  }
}

/* Smooth transitions for responsive breakpoints */
.settings-layout-container {
  transition: all 0.3s ease;
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.addProductServiceSideLine {
  transition: all 0.3s ease;
}

/* Perfect layout alignment - comprehensive responsive */
.settings-layout-container {
  display: flex !important;
  width: 100% !important;
  min-height: 100vh !important;
  position: relative !important;
  overflow: hidden !important;
}

.settings-layout-container .col-2,
.settings-layout-container .col-1 {
  flex-shrink: 0 !important;
  min-height: 0 !important;
  align-self: stretch !important;
  position: relative !important;
  z-index: 10 !important;
  overflow: visible !important;
}

.settings-layout-container .col-10,
.settings-layout-container .col-11,
.settings-layout-container .col-12 {
  flex: 1 !important;
  min-width: 0 !important;
  /* Lets the flex item shrink so overflow-y only appears when content actually overflows */
  min-height: 0 !important;
  position: relative !important;
  z-index: 1 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  margin-left: 0 !important;
  max-width: 100% !important;
}

.addProductServiceSideLine {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  margin-left: 0 !important;
  position: relative !important;
  z-index: 1 !important;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .settings-layout-container {
    width: 100% !important;
    display: flex !important;
  }
  
  .addProductServiceSideLine {
    width: 100% !important;
    margin-left: 0 !important;
    overflow-x: auto !important;
  }
  
  .settings-layout-container .col-10,
  .settings-layout-container .col-11 {
    flex: 1 !important;
    min-width: 0 !important;
  }
}

@media (min-width: 1024px) {
  .settings-layout-container {
    display: flex !important;
    width: 100% !important;
  }
  
  .settings-layout-container .col-2,
  .settings-layout-container .col-1 {
    flex-shrink: 0 !important;
  }
  
  .settings-layout-container .col-10,
  .settings-layout-container .col-11 {
    flex: 1 !important;
    min-width: 0 !important;
    overflow-x: auto !important;
  }
}

@media (max-width: 767px) {
  .settings-layout-container {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .addProductServiceSideLine {
    width: 100% !important;
    margin-left: 0 !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    min-width: 0 !important;
    overflow-x: auto !important;
  }
  
  .addProductServiceSideLine::before {
    content: '';
    /* display: block; */
    height: 80px;
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .addProductServiceSideLine {
    overflow-x: auto !important;
    min-width: 0 !important;
  }
}

@media (max-width: 1400px) {
  .settings-layout-container .col-10,
  .settings-layout-container .col-11 {
    overflow-x: auto !important;
    min-width: 0 !important;
  }
}
